import CreateParkingAreaPage from "./createParkingArea";

export default CreateParkingAreaPage;